// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"304":"caa35472","389":"456af64d","793":"74506c44","990":"b8acf407"}[chunkId] + ".chunk.css";
};